import { useCallback } from 'react'
import GuardianTripScreen from '../../guardian/[token]'
import { seedToursGuardian } from '../../../preview/seed'
import { PreviewSeedBoundary } from '../../../preview/PreviewSeedBoundary'

const TOKEN = 'a'.repeat(64)

export default function PreviewGuardianTripRoute() {
  const seed = useCallback(() => seedToursGuardian(TOKEN), [])

  return (
    <PreviewSeedBoundary seed={seed} seedKey={`guardian:${TOKEN}`}>
      <GuardianTripScreen />
    </PreviewSeedBoundary>
  )
}
